const RUNTIME_LABELS = {
  RUNNING: 'Running',
  SUCCEEDED: 'Succeeded',
  SUCCESS: 'Succeeded',
  FAILED: 'Failed',
  ERROR: 'Failed',
  TIMEOUT: 'Timed out',
  TIMED_OUT: 'Timed out',
  STOPPED: 'Stopped',
  ABORTED: 'Aborted',
  ACTIVE: 'Active',
  IDLE: 'Idle',
  NO_RUNS: 'Idle',
  UNKNOWN: 'Unknown',
  WAITING: 'Waiting',
  STARTING: 'Starting',
  BOOTSTRAPPING: 'Bootstrapping',
  TERMINATED: 'Terminated',
  TERMINATED_WITH_ERRORS: 'Failed',
};

const SUCCESS_STATES = new Set([
  'SUCCEEDED',
  'SUCCESS',
  'ACTIVE',
  'WAITING',
]);

const ERROR_STATES = new Set([
  'FAILED',
  'ERROR',
  'TIMEOUT',
  'TIMED_OUT',
  'ABORTED',
  'TERMINATED_WITH_ERRORS',
]);

const RUNNING_STATES = new Set([
  'RUNNING',
  'STARTING',
  'BOOTSTRAPPING',
  'STARTED',
]);

const IDLE_STATES = new Set(['IDLE', 'NO_RUNS', 'UNKNOWN']);

const ONBOARDING_STATUS_VALUES = new Set([
  'full',
  'partial',
  'none',
  'enabled',
]);

export const getPipelineRuntimeState = (pipeline = {}) => {
  const raw = String(pipeline.status || pipeline.runtime_status || '').trim();
  if (!raw) return '';
  if (ONBOARDING_STATUS_VALUES.has(raw.toLowerCase())) return '';
  return raw;
};

export const getPipelineRuntimeLabel = (pipeline = {}) => {
  const state = getPipelineRuntimeState(pipeline).toUpperCase();
  if (!state) return '';
  return (
    RUNTIME_LABELS[state] ||
    state.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
};

export const getPipelineRuntimeSubtext = (pipeline = {}) => {
  const message = String(pipeline.status_message || '').trim();
  if (message) return message;

  const state = getPipelineRuntimeState(pipeline).toUpperCase();
  if (state === 'RUNNING') return 'In progress';
  if (state === 'IDLE' || state === 'NO_RUNS') return 'No recent runs';
  if (state === 'ACTIVE') return 'Ready';
  if (state === 'SUCCEEDED') return 'Last run succeeded';
  return '';
};

export const getPipelineRuntimeVisual = (state) => {
  const normalized = String(state || '').toUpperCase();

  if (RUNNING_STATES.has(normalized)) {
    return { tone: 'processing', icon: 'sync' };
  }
  if (SUCCESS_STATES.has(normalized)) {
    return { tone: 'success', icon: 'check' };
  }
  if (ERROR_STATES.has(normalized)) {
    return { tone: 'error', icon: 'close' };
  }
  if (IDLE_STATES.has(normalized) || normalized === 'STOPPED' || normalized === 'TERMINATED') {
    return { tone: 'default', icon: 'minus' };
  }
  return { tone: 'default', icon: 'minus' };
};

export const isGluePipeline = (pipeline) =>
  String(pipeline?.type || '').toLowerCase() === 'glue' ||
  String(pipeline?.pipeline_id || '').startsWith('glue_');

export const isStepFunctionsPipeline = (pipeline) => {
  const type = String(pipeline?.type || pipeline?.pipeline_type || '')
    .toLowerCase()
    .replace(/-/g, '_');
  return (
    type === 'step_functions' ||
    type === 'step_function' ||
    String(pipeline?.pipeline_id || '').startsWith('step_functions_')
  );
};

export const hasPipelineRuntimeStatus = (pipeline) =>
  shouldShowPipelineRuntimeStatus(pipeline) &&
  Boolean(getPipelineRuntimeState(pipeline));

export const shouldShowPipelineRuntimeStatus = (pipeline) =>
  !isGluePipeline(pipeline);
